module.exports = __webpack_public_path__ + "static/img/ab-company.092dd25.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/mobile/abouts/ab-company.jpg
// module id = +3gH
// module chunks = 1